import type { FidelityFilters } from './presentationModel';

/** Only report scope is serialized. Host routing and assistant parameters are preserved. */
export const fidelityFilterKeys = [
  'itemStatus',
  'memberType',
  'memberFlag',
  'vendor',
  'product',
  'category',
  'channel',
  'priceBand',
  'priceBandBasis',
  'brand',
  'promoFlag',
  'promoCode',
  'saleType',
  'customerSegment',
  'offerCountry',
  'orderItemCategories',
  'renewalStatus',
  'subscriptionPeriod',
  'isPromo',
  'cancellationStatus',
  'promoSplit',
  'bracketMetric',
  'enrollmentMonth',
] as const;

export function readFidelityFilters(params: URLSearchParams, prefix = ''): FidelityFilters {
  const key = (name: string) => (prefix ? `${prefix}${name[0].toUpperCase()}${name.slice(1)}` : name);
  return {
    market: params.get(key('market')) || 'All markets',
    startDate: params.get(key('from')) || '',
    endDate: params.get(key('to')) || '',
    ...Object.fromEntries(
      fidelityFilterKeys.filter((name) => params.has(key(name))).map((name) => [name, params.get(key(name)) || 'All']),
    ),
  };
}

export function writeFidelityFilters(params: URLSearchParams, values: Partial<FidelityFilters>, prefix = '') {
  const scope = { ...values, from: values.startDate, to: values.endDate };
  for (const name of ['market', 'from', 'to', ...fidelityFilterKeys] as const) {
    if (Object.prototype.hasOwnProperty.call(scope, name) && scope[name] !== undefined) {
      const key = prefix ? `${prefix}${name[0].toUpperCase()}${name.slice(1)}` : name;
      const value = scope[name];
      if (value && value !== 'All markets') {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    } else if (Object.prototype.hasOwnProperty.call(values, name)) {
      const key = prefix ? `${prefix}${name[0].toUpperCase()}${name.slice(1)}` : name;
      params.delete(key);
    }
  }
  return params;
}
